<template>
  <SectionListMetric015
    v-if="contextData"
    :title="contextData.title"
    :description="contextData.description"
    :items="contextData.items"
  />
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    subtitle: string;
    description: string;
  }

  interface IListMetricsSplitData {
    title: string;
    description?: string;
    items: IItem[];
  }

  interface IListMetricsSplit {
    component: 'list-metrics-split';
    meta: {
      navigable?: string;
    };
    data: IListMetricsSplitData;
  }

  type IProps = ISuiteProps<IListMetricsSplit>;

  const props = defineProps<IProps>();

  const contextData = computed(
    (): IListMetricsSplitData => props.suiteData.data
  );

  export type { IItem, IListMetricsSplit, IListMetricsSplitData };
</script>
